import * as React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";


class FlagComment extends React.Component<ComponentProps, ComponentState> {
  public render() {
    return (
      <Dialog open={this.props.show} onClose={this.props.onCancel}>
        <DialogTitle>Report as Inappropriate</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to flag and report this content as inappropriate?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="text" color="primary" onClick={this.onCancel}>Cancel</Button>
          <Button variant="contained" color="primary" autoFocus onClick={this.onConfirm}>Report</Button>
        </DialogActions>
      </Dialog>
    );
  }

  private onConfirm = () => {
    this.props.onConfirm();
  }

  private onCancel = () => {
    this.props.onCancel();
  }
}


interface ComponentProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

interface ComponentState {
}

export default FlagComment;